export const initialValuesAddCommentComHome = {
    comment: "",
}